import ConnectMarketoForm from "./ConnectMarketoForm";
import 'jquery-nice-select';

window.dataLayer = window.dataLayer || [];

const mktoFormConfig = {
    podId: '//info.a16z.com',
    munchkinId: '382-JZB-798',
};

const MKTOFORM_ID_ATTRNAME = 'data-embedded-form-id';

export const initMarketo = () => {
    if (typeof MktoForms2 === 'undefined') return false;

    const marketoFormsIds = [];
    const marketoForms = document.querySelectorAll('[data-embedded-form-id]');
    Array.from(marketoForms).forEach((item) => {
        const formId = item.dataset.embeddedFormId;
        if (parseInt(formId) > 0 && marketoFormsIds.indexOf(formId) === -1) {
            marketoFormsIds.push(formId);
        }
    });

    MktoForms2.whenReady((form) => {

        /*
         * Styling helper for Marketo Form
         */

        let rowId = 0;
        var formElement = form.getFormElem();
        formElement.addClass('mktoForm--styled');
        formElement.find('.mktoField').each(function () {
            var el = jQuery(this),
                parent = el.closest('.mktoFormCol'),
                label = parent.find('label'),
                input = parent.find('input'),
                type = false;

            if(label.text() === '*' || label.text() === '') {
                label.remove();
            }

            if (label.text().includes('|')) {
                [...label].forEach(label => {
                    const old = label.innerHTML;
                    let title = old.substring(old.indexOf('|') + 1, old.lastIndexOf('|'))
                    let desc = old.substring(old.lastIndexOf('|') + 1)
                    const newHtml = `<strong>${title}</strong> ${desc!=='' ? `<span>${desc}</spam>` : ''}`
                    label.innerHTML = newHtml
                })
            }

            if(el.is('input')){
                if(el.attr('type') === 'text' || el.attr('type') === 'email' || el.attr('type') === 'tel') {
                    type = 'input';
                }
                if(el.attr('type') === 'checkbox') {
                    type = input.length > 1 ? 'checkboxes' : 'checkbox';
                    let state = false
                    const btn = el.parents('.mktoFormCol').find('legend')
                    if (btn.text().includes('Select All')) {
                        btn.on('click', function() {
                            input.prop('checked', !state)
                            state = !state
                        })
                    }
                }
                if(el.attr('type') === 'radio') {
                    type = input.length > 1 ? 'radios' : 'radio';
                }
                if (el.attr('type') === 'date') {
                    type = 'date';
                }
            }

            if(el.is('select')){
                type = 'select';
            }
            if(el.is('textarea')){
                type = 'textarea';
            }

            if(el.attr('type') === 'hidden') {
                type = 'hidden';
            }

            if(type){
                parent.addClass('mktoField--'+type);
            }

            if(type == 'hidden') {
                if (el.closest('.mktoFormRow').length) {
                    el.closest('.mktoFormRow').addClass('mktoField--hidden');
                }
            } else {
                if (el.closest('.mktoFormRow').length) {
                    el.closest('.mktoFormRow').addClass('mktoFormRow--' + (rowId++));
                }
            }

            if(el.is('[multiple]')){
                el.attr("size", el.find('option').length);
                parent.addClass('mktoField--multiple');
            }
            if(formElement.find('.mktoPlaceholder').length) {
                formElement.addClass('mktoForm--conditionals');
            }

            if(type == 'input' || type == 'textarea') {
                if (input.attr('placeholder') && input.attr('placeholder') !== false) {
                    input.wrap('<div class="form-group"></div>')
                    input.after(`<label for="${input.attr('id')}" class="placeholder" aria-hidden="true">${input.attr('placeholder').replace('*', '')} ${input.hasClass('mktoRequired') ? '<span>*</span>' : ''}</div>`)
                    input.removeAttr('placeholder');
                } else {
                    input.siblings('label').text().replace('*', '')
                }
            }

            formElement.find('.mktoPlaceholder').each(function () {
                jQuery(this).parents('.mktoFormRow').addClass('has-placeholder');
            });
        });

        formElement.find('fieldset').each(function (index) {
            $(this).addClass('mktoFieldset--' + (index + 1));
            const legend = $(this).find('legend')
            if (legend.text().includes('!')) {
                let txt = legend.text();
                let classes = txt.substring(txt.indexOf('!') + 1, txt.indexOf('!',2))
                legend.html(txt.substring(txt.indexOf('!',2)+1))
                $(this).addClass('mktoFieldset--' + classes)
            }
        })

        form.onSuccess(() => {
            const formInstance = formElement.data('forminstance') || 'default';
            const scrollOnSuccess = formElement.data('scrollOnSubmit') || false;
            const formId = form.getId();

            const trackEvent = (eventName, eventCategory, eventData) => {
                if (typeof gtag === 'function') {
                    try {
                        gtag(eventName, eventCategory, eventData);
                    } catch (error) {
                        console.error('Error calling gtag:', error);
                    }
                }
            };

            trackEvent('event', 'sign_up', {
                'method': `Form ID: ${formId}, Instance: ${formInstance}`
            });

            trackEvent('event', 'MarketoEvent', {
                'form': `Form ID: ${formId}, Instance: ${formInstance}`
            });

            formElement.parents('.marketo--form-wrapper').addClass('success');

            let preventRedirect = true;

            if($('body').hasClass('amangiri-event')) {
                $('body').addClass('amangiri-event-thankyou');
            }

            if(window.mktoform_id_allow_redirect.length && window.mktoform_id_allow_redirect.indexOf(form.getId()) !== -1) {
                preventRedirect = false;
            }

            if (formElement.data('gated-download') && formElement.data('gated-download') === true) {
                preventRedirect = true;
                const downloadLink = formElement.parents('.marketo--form-wrapper').find('.gated-download-link');
                if (downloadLink.length) {
                    downloadLink[0].click();
                }
            }

            if (window.thankyou_page_url && window.thankyou_page_url !== '' && !preventRedirect) {
                window.open(window.thankyou_page_url, '_blank');
            }

            if(scrollOnSuccess) {
                const closest = formElement.closest('.events-register');
                $('html, body').animate({
                    scrollTop: closest.length ? closest.offset().top - 150 : 0
                }, 200);
            }

            // Prevent the page from reloading.
            return false;
        });

        form.onValidate((validationResult) => {
            if (validationResult) {
                form.submittable(true);
            } else {
                if($('#modal-missing-fields').length) {
                    const modalMissingFields = $('#modal-missing-fields');

                    if(formElement.parents('.events-register').length) {
                        const registerComponentID = formElement.parents('.events-register').attr('id').replace('component-','');
                        modalMissingFields.attr('register-component-id', registerComponentID);
                    }

                    modalMissingFields.modal();
                }
                form.submittable(false);

                if ($('.ae-form-section').length){
                    $('html, body').animate({
                        scrollTop: $('.ae-form-section').offset().top - 50
                    }, 1000);
                } else if ($('.events-register').length){
                    $('html, body').animate({
                        scrollTop: $('.events-register').offset().top - 50
                    }, 1000);
                }
            }

            setTimeout(reinitializeNiceSelect, 100);
        });

        $(document).on('focus', '.mktoField--input .mktoField, .mktoField--select .mktoField, .mktoField--textarea .mktoField, .mktoField--date .mktoField', function () {
            $(this).closest('.mktoFieldWrap').addClass('input-active');
        });

        $(document).on('blur', '.mktoField--input .mktoField, .mktoField--select .mktoField, .mktoField--textarea .mktoField, .mktoField--date .mktoField', function () {
            if ('' !== $(this).val()) {
                $(this).closest('.mktoFieldWrap').addClass('input-active');
            } else {
                $(this).closest('.mktoFieldWrap').removeClass('input-active');
            }
        });

        $(document).on('change', '.mktoFormRow select', function (event) {
            const selectName = $(this).attr('name');
            const newValue = {};
            newValue[selectName] = $(this).val();
            form.setValues(newValue);

            if (newValue?.eventRegistrationGuest === 'Yes' ||
                newValue?.privatePlane === 'Yes'||
                newValue?.eventRegistrationSecurity === 'Yes'
            ) {
                $('.ae-form-section').addClass('form-extended')
            }

            if ($(this).val() !== '') {
                $(this).removeClass('mktoInvalid')
            }
        });

        $('#ae-form-submit').click(function (event) {
            event.preventDefault();
            form.submit();
        });
    });

    MktoForms2.whenRendered(function (form) {
        var formElement = form.getFormElem();
        if (formElement.hasClass('mktoForm--conditionals')) {
            formElement.find('.has-placeholder').each(function () {
                var row = jQuery(this);
                if (!row.find('.mktoPlaceholder').length) {
                    var el = row.find('.mktoField'),
                        parent = row.find('.mktoFormCol'),
                        input = parent.find('input'),
                        type = false;

                    if (el.is('input')) {
                        if (el.attr('type') === 'text' || el.attr('type') === 'email' || el.attr('type') === 'tel') {
                            type = 'input';
                        }
                        if (el.attr('type') === 'checkbox') {
                            type = input.length > 1 ? 'checkboxes' : 'checkbox';
                            let state = false
                            const btn = el.parents('.mktoFormCol').find('legend')
                            if (btn.text().includes('Select All')) {
                                btn.on('click', function () {
                                    input.prop('checked', !state)
                                    state = !state
                                })
                            }
                        }
                        if (el.attr('type') === 'radio') {
                            type = input.length > 1 ? 'radios' : 'radio';
                        }
                        if (el.attr('type') === 'date') {
                            type = 'date';
                        }
                    }

                    if (el.is('select')) {
                        type = 'select';
                    }
                    if (el.is('textarea')) {
                        type = 'textarea';
                    }

                    if (el.attr('type') === 'hidden') {
                        type = 'hidden';
                    }

                    if (type) {
                        parent.addClass('mktoField--' + type);
                    }
                }
            });
        }

        $('select').niceSelect();
        $('.nice-select .list').attr('data-simplebar', '');
    });

    Array.from(marketoFormsIds).forEach((formId) => {
        const elements = Array.from(document.querySelectorAll(`
      [${MKTOFORM_ID_ATTRNAME}="${formId}"]
    `));
        if (0 < elements.length) {
            const loadForm = MktoForms2.loadForm.bind(
                MktoForms2,
                mktoFormConfig.podId,
                mktoFormConfig.munchkinId,
                formId
            );

            (function loadFormCb(formEls) {
                const formEl = formEls.shift();
                if (formEl) {
                    formEl.id = `mktoForm_${formId}`;
                }

                loadForm(() => {
                    if (formEl) {
                        formEl.id = '';
                    }

                    if (formEls.length) {
                        loadFormCb(formEls);
                    }
                });
            }(elements));
        }
    });

    const connectFormEl = document.querySelector('[data-newsletter-blocks]');
    if (connectFormEl) {
        const connectForm = new ConnectMarketoForm(mktoFormConfig, connectFormEl);
    }

    function reinitializeNiceSelect() {
        $('.nice-select').remove();
        $('select').show();
        $('select').niceSelect();
        $('.nice-select .list').attr('data-simplebar', '');
    }
}
